import { Component, State, h } from '@stencil/core';
import Cookies from 'js-cookie';

const checkoutLink = `${process.env.CI_HOSTNAME}/checkout/summary`;

@Component({
  tag: 'ci-cart',
  styleUrl: 'ci-cart.scss',
})
export class CiCart {
  @State() cartCookie = Cookies.get('oa_cart');
  @State() showCart = () => this.cartCookie !== undefined;

  cartCount = (cookie: string) => JSON.parse(cookie).order_item_count;

  componentWillLoad() {
    window.addEventListener('cartCookieUpdated', this.refreshCartCookie);
  }

  refreshCartCookie = () => {
    this.cartCookie = Cookies.get('oa_cart');
  };

  disconnectedCallback() {
    window.removeEventListener('cartCookieUpdated', this.refreshCartCookie);
  }

  redirectToCart() {
    window.location.href = checkoutLink;
  }

  render() {
    if (this.showCart()) {
      return (
        <div class="ciHeader-cart">
          <div class="ciHeader-cart-count" onClick={this.redirectToCart}>{this.cartCount(this.cartCookie)}</div>
          <a class="ghf-icon-button ciHeader-cart-icon-button" href={checkoutLink} data-testid="cart-global-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3H3.14551L5.9456 20.7339C6.06072 21.463 6.68914 22 7.42725 22H19C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20H7.85449L7.5387 18H18.3308C19.7807 18 21.0231 16.9631 21.2825 15.5367L22.8767 6.76833C23.0441 5.84757 22.3368 5 21.4009 5H5.48607L5.0544 2.26606C4.93928 1.53698 4.31086 1 3.57275 1H2ZM5.80186 7L7.22292 16H18.3308C18.8141 16 19.2283 15.6544 19.3147 15.1789L20.8018 7H5.80186Z" fill="#4A4A4A"/>
            </svg>
          </a>
        </div>
      );
    }
    return;
  }
}
